const LABELS: Record<string, string> = {
  NONE: 'Not forwarded',
  HTTP: 'HTTP',
  EMAIL: 'Email',
  SMPP: 'SMPP',
  MAILBOX: 'Mailbox',
  SMTP: 'SMTP',
  MM4: 'MM4',
};

export const protocolLabel = (protocol: string | null | undefined) =>
  protocol ? (LABELS[protocol] ?? protocol) : 'Not forwarded';
